import { render, staticRenderFns } from "./Sair.vue?vue&type=template&id=e7a06034"
import script from "./Sair.vue?vue&type=script&lang=js"
export * from "./Sair.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports